__turbopack_context__.v({
  "icon": "P-Cbda_icon",
  "item": "P-Cbda_item",
  "paired-item": "P-Cbda_paired-item",
  "paired-item-dotted-line": "P-Cbda_paired-item-dotted-line",
  "small-margin-top": "P-Cbda_small-margin-top",
});
